import { Link, linkOptions, useParams } from '@tanstack/react-router';
import {
  ChefHat,
  CreditCard,
  Receipt,
  Settings,
  Tags,
  Truck,
  Users,
} from 'lucide-react';
import { useMemo } from 'react';

import { Route as OrganisationSettingsRoute } from '@/app/routes/_authenticated/$tenantId/settings';
import { Route as BillingRoute } from '@/app/routes/_authenticated/$tenantId/settings/billing';
import { Route as LabelsRoute } from '@/app/routes/_authenticated/$tenantId/settings/labels';
import { Route as RecipeTagsRoute } from '@/app/routes/_authenticated/$tenantId/settings/recipe-tags';
import { Route as SuppliersRoute } from '@/app/routes/_authenticated/$tenantId/settings/suppliers';
import { Route as TaxRoute } from '@/app/routes/_authenticated/$tenantId/settings/tax';
import { Route as TeamRoute } from '@/app/routes/_authenticated/$tenantId/settings/team';

const makeNavItems = (tenantId: string) => {
  return [
    linkOptions({
      to: OrganisationSettingsRoute.to,
      label: 'Organisation',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: Settings,
    }),
    linkOptions({
      to: SuppliersRoute.to,
      label: 'Suppliers',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: Truck,
    }),
    linkOptions({
      to: TaxRoute.to,
      label: 'Tax',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: Receipt,
    }),
    linkOptions({
      to: TeamRoute.to,
      label: 'Team',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: Users,
    }),
    linkOptions({
      to: LabelsRoute.to,
      label: 'Labels',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: Tags,
    }),
    linkOptions({
      to: RecipeTagsRoute.to,
      label: 'Recipe Tags',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: ChefHat,
    }),
    linkOptions({
      to: BillingRoute.to,
      label: 'Billing',
      activeOptions: { exact: true },
      params: {
        tenantId,
      },
      icon: CreditCard,
    }),
  ];
};

export function SettingsNav() {
  const { tenantId } = useParams({
    from: '/_authenticated/$tenantId/settings',
  });

  const navItems = useMemo(() => makeNavItems(tenantId), [tenantId]);

  return (
    <nav className="flex flex-col w-64 border-r border-sidebar-border border-slate-300">
      {navItems.map((item) => (
        <Link
          key={item.to}
          className="flex items-center gap-2 px-6 py-3 text-sm outline-none ring-sidebar-ring border-l-4 border-transparent hover:border-l-4 hover:border-sidebar-accent hover:bg-sidebar-accent/50 focus-visible:ring-2 focus-visible:ring-sidebar-ring w-full h-14 [&.active]:border-l-4 [&.active]:border-sidebar-accent [&.active]:bg-sidebar-accent [&.active]:text-sidebar-accent-foreground [&.active]:hover:bg-sidebar-accent"
          {...item}
        >
          <item.icon className="w-4 h-4" />
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
